import React from 'react';
import { Tag } from 'antd';
import { injectIntl } from 'react-intl';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { ROUTE_PACIENTES_CONTACTOLOGY_WATCH } from '../../../../routes.constants';
import ActivityElement from './activityElement';

function Contactologia({ intl, data }:any) {
  const {
    fecha, nombre_tienda, codigo, resumen, tienda_id, tipo_ficha
  } = data;
  const history = useHistory();
  const { pacienteId }: any = useParams();
  let stateColor = '#E6F7FF';
  let stateTextColor = '#049BDD';
  let stateBordercolor = '#91D5FF';
  let nombre_ficha = 'PRUEBA';
  switch (tipo_ficha) {
    case 'P':
      stateColor = '#E6F7FF';
      stateBordercolor = '#91D5FF';
      stateTextColor = '#049BDD';
      nombre_ficha = 'PRUEBA';
      break;
    case 'D':
      stateColor = '#F6FFED';
      stateBordercolor = '#B7EB8F';
      stateTextColor = '#00AC70';
      nombre_ficha = 'DEFINITIVA';
      break;
  }
  const header = (
    <>
      <span className="dateNPlace">
        {fecha}
        {' '}
        /
        {' '}
        {nombre_tienda}
      </span>
      <div className="flexRow">
        <Tag style={{ color: stateTextColor, borderColor: stateBordercolor }} color={stateColor}>{nombre_ficha}</Tag>
      </div>
      <br />
      <p className="blueLink" onClick={() => history.push(generatePath(ROUTE_PACIENTES_CONTACTOLOGY_WATCH, { pacienteId, codigo, tiendaGraduacion: tienda_id }))}>
        {intl.formatMessage({ id: 'pacientes.activity.graduation' })}
        Nº
        {' '}
        {codigo}
      </p>
      <div className="grads flexCol">
        <div className="flexRow">
          <Tag>{intl.formatMessage({ id: 'pacientes.activity.RE' })}</Tag>
          <p>{resumen.resumen_ojo_derecho}</p>
        </div>
        <div className="flexRow lastGrad">
          <Tag>{intl.formatMessage({ id: 'pacientes.activity.LE' })}</Tag>
          <p>
            {resumen.resumen_ojo_izquierdo}
            .
          </p>
        </div>
      </div>
    </>
  );
  return (
    <ActivityElement titleTraductionId="pacientes.activity.contactologies" headerContent={header}>
      {false
      && (
        <div className="flexCol flexEnd">
          <div className="flexRow">
            <div className="marginBot16">
              <p className="blueLink">
                {intl.formatMessage({ id: 'pacientes.activity.documents' })}
              </p>
            </div>
          </div>
        </div>
      )
      }
    </ActivityElement>
  );
}
export default injectIntl(Contactologia);
